import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useSnackbar } from 'notistack';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { addNotification } from '../../state/notifications/Notifications.actions';
import { pushMessageViewed } from '../../state/push/Push.actions';
import { hideSnackbar } from '../../state/snackbar/Snackbar.actions';
import { logToAppInsights } from '../../utils/AppInsights';
import { hasUserPermission } from '../PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../constants/PermissionsEnum';

function StackedNotifications(props) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  React.useEffect(() => {
    if (props.snackbar && props.snackbar.open) {
      logToAppInsights('Snackbar', props.snackbar.message, props.snackbar.type);
      enqueueSnackbar(props.snackbar.message, {
        key: uuidv4(),
        variant: props.snackbar.type,
        autoHideDuration: 10000,
      });

      props._addNotification({
        messageId: `int_${uuidv4()}`,
        message: props.snackbar.message,
        type: 'ui_notification',
        severity: props.snackbar.type,
        time: moment().format('YYYY-MM-DD HH:mm:ss'),
      });

      props._hideSnackbar();
    }

    if (
      props.pushMessages &&
      props.pushMessages.length &&
      hasUserPermission(PermissionsEnum.VIEW_ALERTS)
    ) {
      props.pushMessages.forEach((m) => {
        if (m.Viewed) {
          return;
        }

        var displayText = JSON.parse(m.data).Text;

        logToAppInsights('Snackbar', displayText, 'warning');
        enqueueSnackbar(displayText, {
          key: m.id,
          variant: 'warning',
          autoHideDuration: 10000,
        });

        props._addNotification({
          id: m.id,
          message: displayText,
          type: 'alert',
          instrumentSerialNumber: m.instrumentSerialNumber,
          data: JSON.parse(m.data),
        });

        props._pushMessageViewed(m.id);
      });
    }
  }, [props.snackbar, props.pushMessages]);

  return null;
}

const mapStateToProps = (state) => ({
  snackbar: state.snackbar,
  pushMessages:
    state.push.pushMessages != null && hasUserPermission(PermissionsEnum.VIEW_ALERTS)
      ? state.push.pushMessages.filter((el) => el.type === 'alert')
      : [],
});

const mapDispatchToProps = (dispatch, props) => ({
  _addNotification: (data) => {
    return dispatch(addNotification(data));
  },
  _hideSnackbar: () => dispatch(hideSnackbar()),
  _pushMessageViewed: (id) => dispatch(pushMessageViewed(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StackedNotifications);
